import { render, staticRenderFns } from "./WrappingIcon.vue?vue&type=template&id=f52a799c&lang=pug&"
import script from "./WrappingIcon.vue?vue&type=script&lang=js&"
export * from "./WrappingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports